import React, { useMemo, useState } from "react";

import { SectionEyebrow } from "../components/CommonComponents";
import { ArrowUpRight } from "../components/CommonComponents";
import { DownloadIcon } from "../components/CommonComponents";
import { BookIcon } from "../components/CommonComponents";
import { CalendarIcon } from "../components/CommonComponents";
import { UsersIcon } from "../components/CommonComponents";
import { BriefcaseIcon } from "../components/CommonComponents";
import { cx } from "../components/CommonComponents";

export default function Banner({ course }) {

    return (
        <>
            <section className="relative isolate overflow-hidden bg-[#071A2F] text-white">
                {course.heroImage ? <img src={course.heroImage} alt="" aria-hidden="true" className="absolute inset-0 -z-30 h-full w-full object-cover" /> : null}
                <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(7,26,47,.98)_0%,rgba(7,26,47,.92)_52%,rgba(7,26,47,.72)_100%)]" />
                <div className="absolute inset-0 -z-10 opacity-[0.05] [background-image:linear-gradient(rgba(255,255,255,.24)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.24)_1px,transparent_1px)] [background-size:72px_72px]" />

                <div className="mx-auto w-[min(1380px,calc(100%-48px))] py-16 max-sm:w-[calc(100%-28px)] sm:py-20 lg:py-24">
                    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm text-white/55">
                        <a href="/" className="transition hover:text-[#D5AD57]">Home</a><span>/</span>
                        <a href="/schools" className="transition hover:text-[#D5AD57]">Schools</a><span>/</span>
                        <a href="/programmes" className="transition hover:text-[#D5AD57]">Programmes</a><span>/</span>
                        <span className="text-white">{course.degree}</span>
                    </nav>

                    <div className="mt-12 grid gap-10 lg:grid-cols-[1.15fr_.85fr] lg:items-end">
                        <div>
                            <SectionEyebrow dark>{course.school}</SectionEyebrow>
                            <h1 className="mt-6 max-w-[950px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(46px,6vw,82px)] font-normal leading-[1.02] tracking-[-0.045em]">{course.title}</h1>
                            <p className="mt-7 max-w-[820px] text-base leading-8 text-white/65 sm:text-lg">{course.overview}</p>
                            <div className="mt-8 flex flex-wrap gap-3">
                                <a href="/apply-online" className="inline-flex min-h-[54px] items-center justify-center gap-3 rounded-full bg-[#8B1E3F] px-7 text-sm font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#D5AD57] hover:text-[#071A2F]">Apply Now <ArrowUpRight /></a>
                                <a href="/brochure.pdf" className="inline-flex min-h-[54px] items-center justify-center gap-3 rounded-full border border-white/25 bg-white/[0.05] px-7 text-sm font-bold text-white backdrop-blur transition duration-300 hover:border-[#D5AD57] hover:text-[#D5AD57]"><DownloadIcon /> Download Brochure</a>
                            </div>
                        </div>

                        <aside className="overflow-hidden rounded-[28px] border border-white/15 bg-white/[0.06] backdrop-blur">
                            <div className="border-b border-white/15 px-6 py-5"><span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">Programme Snapshot</span></div>
                            <div className="grid sm:grid-cols-2">
                                {[["Level", course.level, BookIcon], ["Duration", course.duration, CalendarIcon], ["Mode", course.mode, UsersIcon], ["Intake", "As per University norms", BriefcaseIcon]].map(([label, value, Icon]) => (
                                    <div key={label} className="border-b border-r border-white/10 p-6">
                                        <Icon className="h-6 w-6 text-[#D5AD57]" />
                                        <span className="mt-5 block text-sm font-bold uppercase tracking-[0.1em] text-white/40">{label}</span>
                                        <strong className="mt-2 block text-base font-semibold text-white">{value}</strong>
                                    </div>
                                ))}
                            </div>
                        </aside>
                    </div>
                </div>
            </section>

            <section className="border-b border-[#071A2F]/10 bg-[#F7F2E8]">
                <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] md:grid-cols-3">
                    {[["Eligibility", course.eligibility], ["Study Mode", course.mode], ["Campus", "Gariyaband Campus, Raipur Campus"]].map(([label, value]) => (
                        <div key={label} className="border-b border-[#071A2F]/10 px-5 py-6 md:border-b-0 md:border-r">
                            <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">{label}</span>
                            <p className="mt-2 text-sm leading-7 text-[#65717D]">{value}</p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}
